import { useState, useEffect } from "react";
import moment from "moment";

const CreateQuestionnaireTitle = ({
  title,
  setTitle,
  endDate,
  handleDateChange,
}) => {
  const [showDateModal, setShowDateModal] = useState(false);
  const [tempDate, setTempDate] = useState(null);

  const today = moment();

  useEffect(() => {
    if (endDate) {
      setTempDate(moment(endDate));
    }
  }, [endDate]);

  const confirmDate = () => {
    if (!tempDate) return;
    handleDateChange(tempDate.toDate());
    setShowDateModal(false);
  };

  return (
    <>
      {/* Title + Date Row */}
      <div className="flex flex-col md:flex-row gap-4 mb-6">
        {/* Title */}
        <input
          type="text"
          value={title}
          placeholder="Enter Questionnaire Title"
          onChange={(e) => setTitle(e.target.value)}
          className="w-full md:flex-1 text-xl font-medium px-4 py-3 rounded-xl border border-slate-200 shadow-sm focus:outline-none focus:ring-2 focus:ring-mpPurple"
        />

        {/* Date Trigger */}
        <button
          type="button"
          onClick={() => setShowDateModal(true)}
          className="w-full md:w-64 px-4 py-3 rounded-xl border border-slate-200 bg-white text-left text-slate-700 font-medium hover:bg-slate-50"
        >
          {endDate ? moment(endDate).format("DD MMMM YYYY") : "Select end date"}
        </button>
      </div>

      {/* Date Modal */}
      {showDateModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6">
            <h3 className="text-lg font-semibold mb-4">Select end date</h3>

            <input
              type="date"
              min={today.format("YYYY-MM-DD")}
              value={tempDate ? tempDate.format("YYYY-MM-DD") : ""}
              onChange={(e) => setTempDate(moment(e.target.value))}
              className="w-full h-12 px-4 rounded-xl border border-slate-200 text-base focus:outline-none focus:ring-2 focus:ring-mpPurple"
            />

            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => setShowDateModal(false)}
                className="px-4 py-2 rounded-xl border border-slate-300 text-slate-700 hover:bg-slate-100"
              >
                Cancel
              </button>

              <button
                onClick={confirmDate}
                disabled={!tempDate}
                className="px-5 py-2 rounded-xl bg-mpPurple text-white font-semibold hover:opacity-90 disabled:opacity-40"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CreateQuestionnaireTitle;
